import { BodyLarge, Heading2 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import { CasavoInventory } from '@/types/listing'

import FormInfoCasavo from '../FormInfoCasavo'
import FormInfoThirdParty from '../FormInfoThirdParty'

import { formHeaderSubtitle } from './index.css'

type Props = {
  property: ListingCate
}

const FormHeaderDesktop: React.FC<Props> = ({ property }) => {
  const { t } = useTranslation()

  const getHeader = (): string => {
    switch (property.detail.inventory) {
      case CasavoInventory.Agency:
        return 'listing-detail:form-header.subtitle_casavo_inventory_agency'
      case CasavoInventory.iBuyer:
        return 'listing-detail:form-header.subtitle_casavo'
      case CasavoInventory.Third_Party:
        return 'listing-detail:form-header.subtitle_agency'
    }
  }

  return (
    <>
      <div
        className={sprinkles({
          paddingBottom: '2xl',
          textAlign: 'center',
        })}
      >
        <Heading2 className={sprinkles({ marginBottom: 's', whiteSpace: 'pre-wrap' })}>
          {t('listing-detail:form-header.title')}
        </Heading2>
        <BodyLarge className={formHeaderSubtitle}>{t(getHeader())}</BodyLarge>
      </div>
      {property.contactInfo.ownedByCasavo ? (
        <FormInfoCasavo listing={property} />
      ) : (
        <FormInfoThirdParty property={property} />
      )}
    </>
  )
}

export default FormHeaderDesktop
